<template>
  <div class="placeholder-editor">
    <div class="row">
      <label class="placeholder-label small">{{ label }}</label>
    </div>
    <div class="row">
      <div class="col m9 s12">
        <div v-if="isHtml">
          <froala
            tag="textarea"
            :config="froalaConfig"
            @input="$emit('input', localValue)"
            v-model="localValue"
          />
        </div>
        <textarea
          id="editor-textarea"
          v-if="!isHtml"
          @input="$emit('input', localValue)"
          @click="trackPosition"
          @keyup="trackPosition"
          v-model="localValue"
        />
      </div>
      <div class="col m3 s12">
        <placeholder-picker
          @pick="insertPlaceholder"
          :placeholders="placeholders"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PlaceholderPicker from './PlaceholderPicker'
import { froalaOptionsAdvanced as froalaConfig } from '../../../froala'

const basePlaceholders = [
  'SERVICES',
  'FEES',
  'PRICE',
  'ADDRESS',
  'YEAR_BUILT',
  'FOUNDATION',
  'SQUARE_FEET',
  'INSPECTION_DATE',
  'INSPECTION_TIME',
  'INSPECTION_END_TIME',
  'CLIENT_NAME',
  'CLIENT_FIRST_NAME',
  'CLIENT_PHONE',
  'CLIENT_EMAIL',
  'CLIENT_ADDRESS',
  'CLIENT_CONTACT_INFO',
  'AGENT_NAME',
  'AGENT_FIRST_NAME',
  'AGENT_CONTACT_INFO',
  'SELLING_AGENT_NAME',
  'SELLING_AGENT_FIRST_NAME',
  'SELLING_AGENT_CONTACT_INFO',
  'INSPECTOR_NAME',
  'INSPECTOR_PHONE',
  'INSPECTOR_EMAIL',
  'INSPECTION_LINK',
  'INSPECTION_TEXT_LINK',
  'SIGN_AND_PAY_LINK',
  'SIGN_LINK',
  'PAY_LINK',
  'VIEW_REPORT_ON_CLIENT_PORTAL_LINK',
  'REPORT_LINK',
  'REPORT_TEXT_LINK',
  'INVOICE_LINK',
  'INVOICE_TEXT_LINK',
  'REPORT_PDF',
  'SUMMARY_PDF',
  'EVENTS',
  'EVENTS_TEXT',
  'ORDER_ID',
]

export default {
  components: {
    PlaceholderPicker,
  },
  computed: {
    filteredPlaceholders() {
      if (this.filterString.length === 0) {
        return this.placeholders
      }
      return this.placeholders.filter((x) =>
        x.toLowerCase().includes(this.filterString)
      )
    },
    placeholders() {
      if (this.isHtml) {
        return basePlaceholders
      }
      return basePlaceholders.filter((x) => {
        if (!x.endsWith('_LINK')) {
          return true
        }
        if (x.endsWith('TEXT_LINK')) {
          return true
        }
        return false
      })
    },
  },
  data() {
    let vm = this
    return {
      cursorPosition: null,
      filterString: '',
      froala: undefined,
      froalaConfig: Object.assign(froalaConfig, {
        height: 317,
        events: {
          'froalaEditor.initialized': function (e, editor) {
            vm.froala = editor
          },
        },
      }),
      localValue: '',
    }
  },
  methods: {
    insertPlaceholder(value) {
      const wrappedValue = `{{${value}}}`

      if (this.isHtml) {
        this.froala.html.insert(wrappedValue, false)
      } else {
        if (this.cursorPosition) {
          const half1 = this.localValue.slice(0, this.cursorPosition)
          const half2 = this.localValue.slice(
            this.cursorPosition,
            this.localValue.length
          )
          this.localValue = [half1, wrappedValue, half2].join('')
        } else {
          this.localValue += wrappedValue
        }
      }

      this.$emit('input', this.localValue)
    },
    trackPosition() {
      this.cursorPosition =
        document.getElementById('editor-textarea').selectionEnd
    },
  },
  mounted() {
    if (this.value !== undefined) {
      this.localValue = this.value
    }
  },
  props: ['isHtml', 'label', 'value'],
}
</script>

<style lang="scss">
.placeholder-editor {
  width: 100%;

  .placeholder-label {
    padding: 5px;
  }

  .placeholder-buttons {
    .v-btn {
      .v-btn__content {
        justify-content: start;
      }
      background-color: #f9890e !important;
      color: white;
      margin: 3px 0;
      width: 100%;
    }
  }
  .placeholder-buttons {
    border: 1px solid #ddd;
    height: 290px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .v-textarea {
    margin-top: 0;
    textarea {
      border: 1px solid #ddd;
      margin-top: 0;
      padding: 5px;
      background-color: white;
      height: 335px;
    }
  }
}
</style>
